import { render } from "./BirthdayRpt.vue?vue&type=template&id=48b88297&scoped=true"
import script from "./BirthdayRpt.vue?vue&type=script&lang=js"
export * from "./BirthdayRpt.vue?vue&type=script&lang=js"

import "./BirthdayRpt.vue?vue&type=style&index=0&id=48b88297&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b88297"]])

export default __exports__